import { render, staticRenderFns } from "./CsDocuments-RF.vue?vue&type=template&id=10a387e2&"
import script from "./CsDocuments-RF.vue?vue&type=script&lang=js&"
export * from "./CsDocuments-RF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports